import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ClinicalFinding from "../DoctorDashboard/PatientEditProfile/ClinicalFinding";
import GeneralPatient from "../DoctorDashboard/PatientEditProfile/GeneralPatient";
import LicensePatient from "../DoctorDashboard/PatientEditProfile/LicensePatient";
import { useQuery } from "../../Hooks/useApi";

const SuperAdminPatientEditProfile = () => {
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [selectedDiv, setSelectedDiv] = useState(0); // 0 = General, 1 = Clinical, 2 = License

  // Use TanStack Query custom hook for patient details
  const { data: patientResponse } = useQuery(`/user/${id}`);

  // Use TanStack Query custom hook for package details
  const { data: packageResponse } = useQuery(
    `/package/specific?fieldName=userId&&fieldValue=${id}`
  );

  const patient = patientResponse?.data || {};
  const packages = packageResponse?.data?.length ? packageResponse.data[0] : {};

  const tabs = [
    { id: 0, label: "General Information", icon: "solar:user-bold" },
    { id: 2, label: "License Status", icon: "solar:document-bold" },
    { id: 1, label: "Clinical Finding", icon: "solar:medical-kit-bold" },
  ];

  return (
    <div className="max-w-7xl mx-auto select-none space-y-6">
      {/* Header card */}
      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
            <Icon icon="solar:user-speak-bold" className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-lg font-black text-slate-800 tracking-tight">
              Edit Patient Profile
            </h1>
            <p className="text-xs text-slate-400 font-semibold mt-0.5">
              Modify account status, subscription licenses, and clinical observations for {patient?.name}
            </p>
          </div>
        </div>
      </div>

      {/* Tabs Control */}
      <div className="bg-white p-2 rounded-2xl border border-slate-100 shadow-sm flex flex-wrap gap-1">
        {tabs.map((tab) => {
          const isActive = selectedDiv === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setSelectedDiv(tab.id)}
              className={`flex-1 min-w-[150px] py-3 px-4 rounded-xl flex items-center justify-center gap-2 font-extrabold text-xs transition-all duration-300 cursor-pointer ${
                isActive
                  ? "bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-md shadow-cyan-500/10"
                  : "bg-slate-50 text-slate-500 hover:bg-slate-100 hover:text-slate-700"
              }`}
            >
              <Icon icon={tab.icon} className="w-4 h-4" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Tab Content Panel */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        {selectedDiv === 0 && <GeneralPatient patientId={id} />}
        {selectedDiv === 1 && <ClinicalFinding patientId={id} />}
        {selectedDiv === 2 && (
          <LicensePatient
            refetch={refetch}
            setRefetch={setRefetch}
            patientId={id}
            patient={patient}
            packages={packages}
          />
        )}
      </div>
    </div>
  );
};

export default SuperAdminPatientEditProfile;
